import {
  AbcIcon,
  AprovaLiveIcon,
  BeakerIcon,
  CalculatorIcon,
  ComplementaryIcon,
  ContractIcon,
  CornerstoneIcon,
  DnaIcon,
  DumbbellIcon,
  EnemIcon,
  EnglishIcon,
  GlobeIcon,
  IntersectionIcon,
  MoleculeIcon,
  MonitoryIcon,
  OwlIcon,
  PencilIcon,
  RegionsIcon,
  SpanishIcon,
  SquadIcon,
  TempleIcon,
} from 'morpheus-ui';
import { ComponentProps } from 'react';
import { Permissions } from '../../../../accessControl/permissions';
import { anatomiaIcon } from '../../../../components/atoms/AnatomiaIcon';
import {
  bioquimicaIcon,
  embriologiaIcon,
  farmacologiaIcon,
  fisiologiaIcon,
  geneticaIcon,
  histologiaIcon,
  imunologiaIcon,
  microbiologiaIcon,
  parasitologiaIcon,
  patologiaIcon,
} from 'morpheus-ui';

export interface IMenuItem {
  id?: string;
  label: string;
  permission?: Permissions;
  icon: React.ComponentType<ComponentProps<'svg'>> | string;
  iconType: 'material' | 'svg';
  items: ISubMenuItem[];
  href?: string;
  old: boolean;
  clickable: boolean;
}

export interface ISubMenuItem {
  id?: string;
  permission: Permissions;
  label: string;
  icon: React.ComponentType<ComponentProps<'svg'>> | string;
  iconType: 'material' | 'svg';
  iconSize?: 'regular' | 'large';
  link: string;
  old?: boolean;
  isNew?: boolean;
  input?: boolean;
  externalLink?: boolean;
}

// const PLATFORM_URL = env.REACT_APP_PLATFORM_URL;

export const menuItems: IMenuItem[] = [
  {
    label: 'Minha Área',
    permission: Permissions.MINHA_AREA,
    icon: 'home',
    iconType: 'material',
    href: '/',
    old: false,
    clickable: true,
    items: [],
  },
  {
    label: 'Cursos',
    icon: 'ads_click',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/cursos',
    items: [
      {
        permission: Permissions.TRILHAS_DE_ENSINO_CRONOGRAMA_PERSONALIZADO,
        label: 'Cronograma Personalizado',
        icon: 'view_kanban',
        iconType: 'material',
        link: '/plano-adaptativo',
        old: false,
        isNew: true,
      },
      {
        permission: Permissions.TRILHAS_DE_ENSINO_CURSOS_REGULARES,
        label: 'Cursos Regulares',
        icon: 'extension',
        iconType: 'material',
        link: '/cursos/regulares',
        old: false,
        isNew: false,
      },
      {
        permission: Permissions.TRILHAS_DE_ENSINO_CURSOS_COMPLEMENTARES,
        label: 'Cursos Complementares',
        icon: ComplementaryIcon,
        iconSize: 'regular',
        iconType: 'svg',
        old: false,
        link: '/cursos/complementares',
        isNew: false,
      },
      {
        permission: Permissions.TRILHAS_DE_ENSINO_TREINO_DE_ELITE,
        label: 'Estudo por Questões',
        icon: DumbbellIcon,
        iconSize: 'regular',
        iconType: 'svg',
        old: false,
        link: '/cursos/minicurso-treino-de-elite/detalhes',
        isNew: false,
      },
      {
        permission: Permissions.TRILHAS_DE_ENSINO_ESQUADRAO,
        label: 'Esquadrão',
        icon: SquadIcon,
        iconSize: 'regular',
        iconType: 'svg',
        old: false,
        link: '/cursos/esquadrao-elite/detalhes',
        isNew: false,
      },
      {
        permission: Permissions.TRILHAS_DE_ENSINO_REGIONAIS,
        label: 'Regionais',
        icon: RegionsIcon,
        iconSize: 'regular',
        iconType: 'svg',
        link: '/regionais',
        isNew: false,
        old: false,
      },
    ],
  },
  {
    label: 'Disciplinas',
    icon: 'neurology',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/disciplinas',
    items: [
      {
        permission: Permissions.DISCIPLINAS_INTERDISCIPLINAR,
        label: 'Interdisciplinar',
        icon: IntersectionIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/interdisciplinar',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_BIOLOGIA,
        label: 'Biologia',
        icon: DnaIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/biologia',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_FISICA,
        label: 'Física',
        icon: MoleculeIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/fisica',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_QUIMICA,
        label: 'Química',
        icon: BeakerIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/quimica',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_MATEMATICA,
        label: 'Matemática',
        icon: CalculatorIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/matematica',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_HISTORIA,
        label: 'História',
        icon: CornerstoneIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/historia',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_GEOGRAFIA,
        label: 'Geografia',
        icon: GlobeIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/geografia',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_ATUALIDADES,
        label: 'Atualidades',
        icon: ContractIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/atualidades',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_FILOSOFIA,
        label: 'Filosofia',
        icon: OwlIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/filosofia',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_SOCIOLOGIA,
        label: 'Sociologia',
        icon: TempleIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/sociologia',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_PORTUGUES,
        label: 'Português',
        icon: PencilIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/portugues',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_LITERATURA,
        label: 'Literatura',
        icon: AbcIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/literatura',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_REDACAO,
        label: 'Redação',
        icon: AbcIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/redacao',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_INGLES,
        label: 'Inglês',
        icon: EnglishIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/ingles',
        isNew: false,
      },
      {
        permission: Permissions.DISCIPLINAS_ESPANHOL,
        label: 'Espanhol',
        icon: SpanishIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/espanhol',
        isNew: false,
      },
    ],
  },
  {
    label: 'Universitário',
    icon: 'school',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/disciplinas',
    items: [
      {
        id: '6744f33373342c8bdf624e8e',
        link: '/disciplinas/bioquimica-superior',
        label: 'Bioquímica',
        icon: bioquimicaIcon,
        permission: Permissions.DISCIPLINAS_BIOQUIMICA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f2ce73342c8bdf624b31',
        link: '/disciplinas/anatomia-superior',
        label: 'Anatomia Humana',
        icon: anatomiaIcon,
        permission: Permissions.DISCIPLINAS_ANATOMIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f3a173342c8bdf62523c',
        link: '/disciplinas/histologia-humana-superior',
        label: 'Histologia Humana',
        icon: histologiaIcon,
        permission: Permissions.DISCIPLINAS_HISTOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '67a649de53385405e8347d57',
        link: '/disciplinas/fisiologia-superior',
        label: 'Fisiologia Humana',
        icon: fisiologiaIcon,
        permission: Permissions.DISCIPLINAS_FISIOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '67a649e94a2955b1abd77d7a',
        link: '/disciplinas/genetica-superior',
        label: 'Genética',
        icon: geneticaIcon,
        permission: Permissions.DISCIPLINAS_GENETICA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '67a649c2b5df925acf3d5ae2',
        link: '/disciplinas/embriologia-superior',
        label: 'Embriologia',
        icon: embriologiaIcon,
        permission: Permissions.DISCIPLINAS_EMBRIOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f40a73342c8bdf6255c0',
        link: '/disciplinas/imunologia-superior',
        label: 'Imunologia',
        icon: imunologiaIcon,
        permission: Permissions.DISCIPLINAS_IMUNOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f47773342c8bdf625936',
        link: '/disciplinas/microbiologia-superior',
        label: 'Microbiologia',
        icon: microbiologiaIcon,
        permission: Permissions.DISCIPLINAS_MICROBIOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f51e73342c8bdf625ed2',
        link: '/disciplinas/parasitologia-superior',
        label: 'Parasitologia',
        icon: parasitologiaIcon,
        permission: Permissions.DISCIPLINAS_PARASITOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f4c973342c8bdf625bfc',
        link: '/disciplinas/patologia-superior',
        label: 'Patologia',
        icon: patologiaIcon,
        permission: Permissions.DISCIPLINAS_PATOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '67a649d154e8a222fe439241',
        link: '/disciplinas/farmacologia-superior',
        label: 'Farmacologia',
        icon: farmacologiaIcon,
        permission: Permissions.DISCIPLINAS_FARMACOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
    ],
  },
  {
    label: 'Redação',
    icon: 'edit',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/redacoes',
    items: [
      {
        permission: Permissions.REDACAO_MINHAS_REDACOES,
        label: 'Minhas Redações',
        icon: 'stylus',
        iconType: 'material',
        link: '/redacoes/minhas_redacoes',
        old: false,
        isNew: false,
      },
      {
        permission: Permissions.REDACAO_TEMAS,
        label: 'Temas de Redação',
        icon: 'list',
        iconType: 'material',
        link: '/redacoes/temas',
        old: false,
        isNew: false,
      },
    ],
  },
  {
    label: 'Exercícios',
    icon: 'list_alt',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/simulado',
    items: [
      {
        permission: Permissions.SIMULADOS_SIMULADOR,
        label: 'Banco de Questões',
        icon: 'quiz',
        iconType: 'material',
        link: '/banco-questoes',
        old: false,
        isNew: true,
      },
      {
        permission: Permissions.SIMULADOS_SIMULADOR,
        label: 'Simulador',
        icon: DumbbellIcon,
        iconSize: 'regular',
        iconType: 'svg',
        link: '/simulados/provas',
        old: false,
        isNew: false,
      },
      {
        permission: Permissions.SIMULADOS_SIMULADOS_ENEM,
        label: 'Simulados Enem',
        icon: EnemIcon,
        iconSize: 'regular',
        iconType: 'svg',
        link: '/simulados/enem',
        old: false,
        isNew: false,
      },
      {
        permission: Permissions.SIMULADOS_SIMULADOS_ENEM,
        label: 'Provas ENEM',
        icon: 'history_edu',
        iconType: 'material',
        link: '/area-enem',
        old: false,
        isNew: true,
      },
      {
        label: 'Flashcards',
        icon: 'timelapse',
        permission: Permissions.MEMORY,
        iconType: 'material',
        old: false,
        link: '/memory',
      }
    ],
  },
  {
    label: 'Conexões com Jubilut',
    permission: Permissions.CONEXOES_JUBILUT,
    icon: 'diversity_3',
    iconType: 'material',
    old: false,
    clickable: true,
    href: '/conexoes-jubilut',
    items: [],
  },
  {
    label: 'Ao Vivo',
    icon: 'online_prediction',
    iconType: 'material',
    old: false,
    href: '/ao-vivo',
    clickable: false,
    items: [
      {
        permission: Permissions.AO_VIVO_MONITORIAS,
        label: 'Monitorias',
        icon: MonitoryIcon,
        iconSize: 'regular',
        iconType: 'svg',
        link: '/ao-vivo/monitorias',
        old: false,
        isNew: false,
      },
      {
        permission: Permissions.AO_VIVO_LIVES,
        label: 'Lives',
        icon: 'live_tv',
        iconType: 'material',
        link: '/ao-vivo/lives',
        old: false,
        isNew: false,
      },
      {
        permission: Permissions.AO_VIVO_APROVA_LIVE,
        label: 'AprovaLive',
        icon: AprovaLiveIcon,
        iconSize: 'regular',
        iconType: 'svg',
        link: '/ao-vivo/aprova-live',
        old: false,
        isNew: false,
      },
      // {
      //   permission: Permissions.AO_VIVO_CHALLENGE_60_DIAS,
      //   label: 'Desafio 60 dias',
      //   icon: AprovaLiveIcon,
      //   iconSize: 'regular',
      //   iconType: 'svg',
      //   link: '/ao-vivo/desafio-60-dias',
      //   old: false,
      //   isNew: false,
      // },
    ],
  },
];

export interface ISideMenuItem {
  icon: string;
  iconType: 'material' | 'svg';
  clickable: boolean;
  items: ISideMenuSubItem[];
  permission?: Permissions;
}

export interface ISideMenuSubItem {
  label: string;
  icon: string | React.ComponentType<ComponentProps<'svg'>>;
  iconType: 'material' | 'svg';
  iconSize?: 'regular' | 'large';
  link: string;
  old?: boolean;
  input?: boolean;
  externalLink?: boolean;
  permission?: Permissions;
  isNew?: boolean;
}

export const sideMenuItems: ISideMenuItem[] = [
  // {
  //   icon: 'search',
  //   iconType: 'material',
  //   clickable: false,
  //   items: [
  //     {
  //       label: 'O que você está procurando?',
  //       input: true,
  //     },
  //   ],
  // },
  // {
  //   label: 'mural',
  //   icon: 'grid_view',
  //   iconType: 'material',
  //   old: true,
  //   href: PLATFORM_URL + '/mural',
  //   clickable: true,
  //   items: [],
  // },
  {
    icon: 'menu',
    iconType: 'material',
    clickable: false,
    items: [
      {
        label: 'Favoritos',
        icon: 'star',
        iconType: 'material',
        link: '/favoritos',
        old: false,
        permission: Permissions.FAVORITOS,
      },
      {
        label: 'Comunidade',
        icon: 'supervisor_account',
        iconType: 'material',
        link: '/comunidade',
        permission: Permissions.COMUNIDADE,
      },
      {
        label: 'Perfil',
        icon: 'person',
        iconType: 'material',
        link: '/perfil',
      },
      {
        label: 'Fale conosco',
        icon: 'contact_support',
        iconType: 'material',
        link: 'https://ajuda.aprovatotal.com.br/hc/aprova-total/pt_BR',
        externalLink: true,
        permission: Permissions.ALUNO_APROVA_TOTAL,
      },
      {
        label: 'Indicação',
        icon: 'group_add',
        iconType: 'material',
        link: '/referidos',
        old: false,
      },
      {
        label: 'Sair',
        icon: 'logout',
        iconType: 'material',
        link: '/logout',
        old: false,
      },
    ],
  },
];
